import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  vehiclesNearYouTitle: {
    marginBottom: 20,
    fontSize: 36,
    lineHeight: "1.22",
    fontWeight: 500,
    textAlign: "left",
  },
  vehiclesNearYouContainer: {
    marginTop: 130,
    marginBottom: 84,
    scrollMarginTop: "100px",
    [theme.breakpoints.down("sm")]: {
      minHeight: 137,
      marginTop: 80,
    },
  },
  mobileCenteredText: {
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto",
    },
  },
  desktopFlex: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "flex-start",
    },
  },
  nearbyVehiclesButton: {
    margin: "0 auto",
    display: "block",
    fontSize: 21,
    fontWeight: 400,
    padding: "8px 55px",
    marginTop: 5,
    marginBottom: 5,
    border: `2px solid ${theme.palette.primary.main}`,
    "&:hover": {
      borderWidth: 2,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 15,
    },
  },
  linkWrapper: {
    "&:hover": {
      textDecoration: "none",
    },
    textDecoration: "none",
  },
  footer: {
    marginTop: 32,
    marginBottom: 30,
  },
}));
